import * as $ from 'jquery'
import Api from '../../lib/Api';
import ChatClient from '../../lib/ChatClient';
import Utils from '../../lib/Utils'
import Const from '@/util/const'

const CLOSING_STATUSES = ['resolved', 'leave_timed_out', 'room_timed_out','calling_failed']
const LOADING_TIME = 700
const NEXT_FAQ_TIME = 500

export default {
  name: 'ChatMessages',
  props: [
    'room',
    'senderId',
    'senderName',
    'senderType',
    'isAfterBusinessHour',
    'messageLoading',
    'displayVisibilityState'
  ],

  data: function() {
    return {
      roomId: null,
      messages: [],
      productCategory: "",
      troubleCategory: "",
      initMessage: [],
      chatbotMessage: [],
      newRoomFlg: false,
      closedRoomFlg: false,
      newChatClick: false,
      messagesRead: '',
      frequentlyQuestionFlg: false,
      existFrequentlyQuestion: false,
      categoryValue: "",
      troubleCategoryValue: "",
      callOperatorFlg: false,
      existCallingOperator: false
    }
  },

  ///// options /////
  api: null,
  chatClient: null,

  created: function () {
    // viewNewChatをOFFにする
    this.$emit("view-new-chat", false)

    this.$options.api = new Api();
    if (this.room) {
      this.$options.api.currentRoomStatus(this.room.id).then(res => {
        if (this.room && res.data.length > 0) {
          this.enterRoom(this.room.id, this.room.accessToken);
        }
        else { // 現在のルームが解決済みの場合は新規ルームを作成
          this.createNewRoom();
        }
      })
      .catch(err => {
        window.alert('ネットワークが不安定な為、通信に時間がかかっています。', err);
      });
    } else {
      this.createNewRoom();
    }
    this.$options.chatClient.isWaitingResponse = false
  },
  updated: function () {
    // 読込アニメーション表示中は処理を中断する
    if (this.messageLoading) return 
    this.$options.chatClient.isWaitingResponse = false
    let height = $(this.$refs.root).prop('offsetHeight')
    const productCodes = this.messages.filter((message) => message.context === 'set-product-code')
    if (productCodes.length > 0) {
      const latestProductCode = productCodes[productCodes.length - 1].content.product_code
      this.productCode = latestProductCode
    }
    const productCategories = this.messages.filter((message) => message.context === 'set-product-category')
    if (productCategories.length > 0) {
      this.$parent.productCategory = productCategories[productCategories.length - 1].content.question_category      
    }

    if (this.messages.length - 2 > 0) {
      if (this.messages[this.messages.length - 2].context === 'frequently-question' || this.messages[this.messages.length - 2].context === 'question') {
        // 最後のメッセージがよくある質問の場合はスクロールを調整する
        // context「frequently-question」「question」の要素のoffsetTopを取得して、スクロール位置を計算
        let chatmessagesTop = $(this.$refs.root).offset().top
        let targetElemntTop = $(this.$refs.root).children().eq(this.messages.length - 1).offset().top
        height = targetElemntTop - chatmessagesTop
      }
    }

    this.$emit('update-messages', height)
  },
  beforeDestroy: function () {
    this.stopFetch();
    this.$emit('stop-polling')
  },

  computed: {
    productCode: {
      get() {
        this.$parent.productCode
      },
      set(value) {
        this.$emit('set-product-code', value)
      }
    }
  },
  watch: {
    room (newRoom) {
      if (newRoom) {
        if (this.roomId !== newRoom.id) {
          this.stopFetch();
          this.$emit('stop-polling')
          this.messages = [];
          this.enterRoom(newRoom.id, newRoom.accessToken);
        }
        else {
          // no-op
        }
      }
      else {
        this.stopFetch();
        this.$emit('stop-polling')
        this.messages = [];
        this.newRoomFlg = true
        this.newChatClick = true
        this.createNewRoom();
        // botメッセージ内のボタン制御用フラグ
        this.closedRoomFlg = false;
        // botの固定メッセージ制御用フラグ
        this.frequentlyQuestionFlg = false
        // botメッセージ制御用フラグ
        this.callOperatorFlg = false
      }
    }
  },
  methods: {
    /*
     * 新規ルーム作成
     */
    createNewRoom () {
      let create = this.$options.api.createRoom();
      create.then(res => {
        let newRoom = res.data;
        console.log(`New chat room: ${newRoom.id}`);
        this.newRoomFlg = true

        // this.$options.api.attachBot(newRoom);
        this.enterRoom(newRoom.id, newRoom.access_token);
      })
      .catch(err => {
        console.log(err);
        window.alert('チャットルームの作成に失敗しました。');
      });
    },

    enterRoom (roomId, roomAccessToken) {
      this.roomId = roomId
      this.$options.api.roomAccessToken = roomAccessToken;
      this.startFetchMessage(roomId);
      this.startFetchRoomState(roomId);
      this.$emit('enter-room', {
        roomId: roomId,
        roomAccessToken: roomAccessToken
      })

      // 最新滞在時間を通知
      this.$emit('create-notice-timer')
      if (this.newChatClick) {
        // 「新しいチャットを開始」にてルーム生成した場合
        // 営業時間、オペレーター空き状況のAPIを呼び出す
        this.$emit('reload-system-state')
      }
    },
    /*
     * 初期メッセージ表示
     */
    initialMessage () {
      let now = new Date();
      return [
        {
          "id": 'initail-0',
          "version": "1.0",
          "type": "Text",
          "sender": ChatClient.BOT_USER,
          "created_at": now,
          "content": {
            "text": "お問い合わせありがとうございます。\n\ 次の内容にご回答のうえ、お進みください。",
            "freetext_processible": false,
            "isLoading": true
          }
        },
        {
          "id": 'initial-1',
          "version": "1.0",
          "type": "ProductCategorySelect",
          "sender": ChatClient.BOT_USER,
          "created_at": now,
          "content": {
            "text": "次のうち、どの製品に関するお問い合わせですか？",
            "categories": [
              {"value": "tv", "label": "テレビ"},
              {"value": "bd", "label": "BD/DVD"}
            ],
            "freetext_processible": false
          }
        }
    
    ]
    },

    /*
     * メッセージ取得ロングポーリング開始
     */
    startFetchMessage: function (roomId) {
      this.$options.chatClient = new ChatClient(this.$options.api, roomId);
      this.$options.chatClient.sender = {
        id: this.senderId,
        name: this.senderName,
        role: this.senderType
      }
      //ここに初期メッセージを追加
      this.initMessage = this.initialMessage()

      if (this.newRoomFlg) {
        // 新規ルームの場合

        // viewNewChatをONにする
        this.$emit("view-new-chat", true)

        // メッセージ取得中のアニメーションが表示された状態で新しいチャットを選択された時を考慮した制御
        this.$emit("set-message-loading", false)

        this.messages.push(this.initMessage[0])
        setTimeout(() => {
          // 1つ目のアニメーションOFFに変更後、2つ目のメッセージを挿入
          this.messages[0].content.isLoading = false;
          this.messages.push(this.initMessage[1]);
        }, LOADING_TIME)
      } else {
        // 既存ルームの場合
        // メッセージ取得中のアニメーションをONにする
        this.$emit("set-message-loading", true)
      }
      
      this.$options.chatClient.onFetchMessage = (newMessages) => {
        if (!this.newRoomFlg && this.messageLoading) {
          // 既存ルーム、メッセージ取得アニメーションがONの場合
          // メッセージ取得中のアニメーションをOFFにする
          this.$emit("set-message-loading", false)
          // 初期メッセージをthis.messagesに挿入する
          this.initMessage[0].content.isLoading = false
          this.messages = this.initMessage

          // viewNewChatをONにする
          this.$emit("view-new-chat", true)
        }

        // 既読情報の設定
        if (this.displayVisibilityState === Const.stateVisible) {
          // 画面表示中の場合
          // 非表示時は既読更新しないようにする
          this.$options.api.updateReadDisplay(roomId)
          .catch(err => {
            console.log(err)
          })
        }
        this.existFrequentlyQuestion = newMessages.some(function(element){
          return element.context === "frequently-question";
        });

        this.existCallingOperator = newMessages.some(function(element){
          return element.context === "calling-operator";
        });
        if (newMessages.length > 0) {
          // メッセージが1件でも取得できた場合
          // ロードアニメーション制御フラグをbotメッセージに追加する
          let editMessages = []
          editMessages = this.setLoadingFlg(newMessages)

          // 通常時は1秒後にロードアニメーションをOFFにするタイマーをセットする
          if (editMessages.length === 1 || (editMessages.length === 2 && this.existFrequentlyQuestion) || (editMessages.length === 2 && this.existCallingOperator)) {
            setTimeout(() => {this.messages.forEach((message) => {
              if (message.content.isLoading) {
                message.content.isLoading = false
              }

              if (!this.frequentlyQuestionFlg && message.context == 'frequently-question') {
                this.frequentlyQuestionFlg = true
              }
              if (!this.callOperatorFlg && message.context == "calling-operator") {
                this.callOperatorFlg = true
              }
            })}, LOADING_TIME)
          } else {
            if (!this.frequentlyQuestionFlg && this.existFrequentlyQuestion > 0) {
              this.frequentlyQuestionFlg = true
            }
            if (!this.callOperatorFlg && this.existCallingOperator) {
              this.callOperatorFlg = true
            }
          }
          this.$emit('fetch-new-messages', editMessages);
        }
      };
      this.$options.chatClient.startFetchMessage();
    },

    /*
     * ロードアニメーション制御フラグを追加
     */
    setLoadingFlg: function (newMessage) {
      let returnMessage = newMessage
      if (newMessage.length === 1 || (newMessage.length === 2 && this.existFrequentlyQuestion)|| (newMessage.length === 2 && this.existCallingOperator)) {
        returnMessage = newMessage.map((value) => {
          if (value.sender.role === "bot") {
            if (value.type === "secondText") return value
            if (value.context === "calling-operator-second") return value
            value.content["isLoading"] = true
          }
          return value
        })
      }

      // 「次の5件」用のアニメーション制御フラグを追加
      returnMessage = returnMessage.map((value) => {
        value.content["faqIsLoading"] = false
        return value
      })

      // 編集したメッセージを画面表示用のデータに追加する
      this.messages.push(...returnMessage)

      return returnMessage
    },

    /*
     * メッセージ取得ロングポーリング開始
     */
    startFetchRoomState: function (roomId) {
      console.log(this.room)
      this.$options.chatClient = new ChatClient(this.$options.api, roomId);
      this.$options.chatClient.sender = {
        id: this.senderId,
        name: this.senderName,
        role: this.senderType
      }
      this.$options.chatClient.onFetchRoomState = (res) => {
        if (res.state == "op_responding" || res.state == "sv_responding") {
          // メッセージ既読状態取得ポーリング開始
          this.$emit('start-polling')
        }
        if (!CLOSING_STATUSES.includes(res.state)) return
        console.log("The chat was closed")
        this.$emit('chat-is-closed');
        // botメッセージ内のボタン制御用フラグ
        this.closedRoomFlg = true;
      };
      this.$options.chatClient.onErrorRoomState = (err) => {
        console.log(err)
        console.log("The chat was closed")
        this.$emit('chat-is-closed')
        // botメッセージ内のボタン制御用フラグ
        this.closedRoomFlg = true;
      }
      this.$options.chatClient.startFetchRoomState();
    },

    stopFetch: function () {
      if (this.$options.chatClient) {
        this.$options.chatClient.stopFetch();
      }
    },

    isButtonSelected (label, index) {
      const nextKey = index + 1
      const nextMessage = this.messages[nextKey]
      if (! nextMessage) return false

      return nextMessage.content.text == label
    },

    /*
     * アニメーション後に表示するメッセージ
     */
    loadingDisplayMessageText: function (msg) {
      if (msg.type === 'Text' && !msg.content.isLoading && (msg.context != 'frequently-question-second' && msg.context != 'calling-operator-second')) return true
      if (msg.context === 'frequently-question-second' && this.frequentlyQuestionFlg ) return true
      if (msg.context === 'calling-operator-second' && this.callOperatorFlg) return true
      return false
    },

    /*
     * メッセージテキスト
     */
    displayMessageText: function (msg) {
      let text = msg.content.text
      return Utils.prepareLongTextValue(text)
    },

    /*
     * メッセージ送信者名
     */
    displaySenderName: function (sender) {
      if (sender.name) return sender.name
      if (sender.id) return sender.id
      if (sender.role) return sender.role
      return ''
    },

    /*
     * メッセージroomID
     */
    displayMessageRoomId: function (role) {
      if (role !== 'user') return
      return "(ID:" + this.roomId + ")"
    },

    /*
     * チャット上のボタン押下 (userユーザーのみ)
     */
    onClickButton: function (type, btn) {

      if (this.senderType !== 'user') return

      if (this.$options.chatClient) {
        this.$emit("set-message-loading", true)
        this.$options.chatClient.sendButtonClick(type, btn)
      }
    },

    /*
     * FAQ後の判定ボタン押下 (userユーザーのみ)
     */
    onClickAnswerFeedbackButton (event) {
      if (this.$options.chatClient.isWaitingResponse) return
      if (this.senderType !== 'user') return

      const resolveStatus = event.target.parentElement.value === "true"
      const label = event.target.innerText
      if (!this.$options.chatClient) return

      if (!resolveStatus) {
        // 「解決しなかった」が選択された場合、営業時間を取得し直す
        this.$emit("set-business-hours")
      }
      this.$emit("set-message-loading", true)
      this.$options.chatClient.sendAnswerFeedback(label, resolveStatus)
    },

    /*
     * 固定FAQ後の判定ボタン押下 (userユーザーのみ)
     */
    onClickFrequentlyQuestionAnswerFeedbackButton(event) {
      if (this.$options.chatClient.isWaitingResponse) return
      if (this.senderType !== 'user') return

      const resolveStatus = event.target.parentElement.value === "true"
      const label = event.target.innerText
      if (!this.$options.chatClient) return

      this.$emit("set-message-loading", true)
      this.$options.chatClient.sendAnswerFrequentlyQuestionFeedback(label, resolveStatus)
    },

    // 製品選択ボタン押下
    onClickProduct (product) {
      if (this.senderType !== 'user') return

      if (this.$options.chatClient) {
        this.$emit("set-message-loading", true)
        this.$options.chatClient.sendProductSelect(product.id, product.name)
      }
    },

    onClickProductCategory (category) {
      if (this.senderType !== 'user') return

      this.$parent.productCategory = category
      this.$parent.rawProductCode = ''
      if (!this.$options.chatClient) return
      if (this.$options.chatClient.isWaitingResponse) return

      this.$emit("set-message-loading", true)
      this.$options.chatClient.sendProductCategory(category)
    },

    onClickTroubleCategory (category) {
      if (this.senderType !== 'user') return
      this.$parent.troubleCategory = category
      if (!this.$options.chatClient) return
      if (this.$options.chatClient.isWaitingResponse) return
    
      this.$emit("set-message-loading", true)
      this.$options.chatClient.sendTroubleCategory(category, this.$parent.productCategory)
    },

    onClickAnswerCard (answer) {
      window.open(answer.url)
    },

    onClickFaqPageLink () {
      let target = ''
      const category = this.$parent.productCategory
      switch (category) {
        case 'tv':
          target = 'https://faq-cs.regza.com/faq/tv/faqList'
          break;
        case 'bd':
          target = 'https://faq-cs.regza.com/faq/bdDvd/faqList'
          break;
        default:
          target = 'https://faq-cs.regza.com/faq/tv/faqList'
          break;
      }
      window.open(target)
    },

    onClickAskFrequentlyFaqChatbot(event) {
      if (this.senderType !== 'user') return
      if (!this.$options.chatClient) return
      if (this.$options.chatClient.isWaitingResponse) return

      const label = event.target.innerText
      this.$emit("set-message-loading", true)
      this.categoryValue = this.$parent.productCategory
      this.troubleCategoryValue = this.$parent.troubleCategory.value
      this.$options.chatClient.sendRequestFrequentlyFaqChatbot(label, this.categoryValue, this.troubleCategoryValue);
    },

    onClickAskChatbot(event) {
      if (this.senderType !== 'user') return
      if (!this.$options.chatClient) return
      if (this.$options.chatClient.isWaitingResponse) return

      const label = event.target.innerText
      this.$emit("set-message-loading", true)
      this.$options.chatClient.sendRequestFaqChatbot(label);
    },

    onClickSubmitProductCode() {
      if (this.senderType !== 'user') return
      if (!this.$options.chatClient) return
      if (this.$options.chatClient.isWaitingResponse) return
      console.log(this.$parent.productCode)
      this.$emit("set-message-loading", true)
      const category = this.$parent.productCategory
      this.$options.chatClient.sendProductCode(this.$parent.productCode, category)
    },

    // 製品比較テーブルのヘッダー
    createProductCompareHeaders (products) {
      let headers = [
        {
          text: '仕様',
          value: 'prop_name',
          sortable: false,
          align: 'left'
        }
      ]
      for (let product of products) {
        headers.push({
          text: product.product_name,
          value: product.product_id,
          sortable: false,
          align: 'left'
        })
      }
      return headers
    },

    // 製品比較テーブルの行
    createProductCompareItems (specs) {
      return specs.map(spec => {
        let item = {
          prop_name: spec.name,
          prop_url: spec.url
        }
        for (let productId in spec.values) {
          item[productId] = spec.values[productId]
        }
        return item
      })
    },

    // 画像添付メッセージか否か
    messageIsImageFile (msg) {
      if (msg.type !== 'File') return false
      if (!msg.content.file) return false
      if (!msg.content.file.type) return false

      return msg.content.file.type.indexOf('image/') === 0
    },

    // PDF添付メッセージか否か
    messageIsPdfFile (msg) {
      if (msg.type !== 'File') return false
      if (!msg.content.file) return false
      if (!msg.content.file.type) return false

      return msg.content.file.type === 'application/pdf'
    },

    // 添付ファイル取得URL
    createFileURL (msg) {
      if (msg.type !== 'File') return ''

      let roomId = msg.content.room_id
      let fileId = msg.content.file_id
      let accessToken = msg.content.access_token
      return this.$options.api.getRoomFileURL(roomId, fileId, accessToken)
    },

    // 添付ファイルサイズ表示文字列
    toFileSizeString (size) {
      let units = ['K', 'M', 'G', 'T']
      let currentUnit = ''
      let currentSize = size

      for (let unit of units) {
        let nextSize = Math.floor(currentSize / 1000)
        if (nextSize <= 0) break

        currentSize = nextSize
        currentUnit = unit
      }

      return `${currentSize} ${currentUnit}Bytes`
    },

    latestMessage() {
      return this.messages[this.messages.length - 1]
    },

    isMessageHead (message) {
      return this.latestMessage().id == message.id
    },

    toNewChat () {
      console.log(this.room)
      this.$emit("toNewChat")
    },

    callOperator (event) {
      if (this.$options.chatClient.isWaitingResponse) return
      const label = event.target.innerText
      this.$emit("set-message-loading", true)
      this.$options.chatClient.sendOperatorCall(label, this.room)
    },
    
    // FAQデータ「次の5件」を追加表示
    onClickNextFaqButton (event) {
      var index = this.messages.length - 1
      var target = $(event.target).parents('.displayFaq')
      var faqAnswers = target.parent().find(".answerData").children()
      var defaultStyle = target.find('.nextFaq').attr('style')
      let height = $(this.$refs.root).prop('offsetHeight')
      this.messages[index].content.faqIsLoading = true
      // アニメーション表示時に高さがずれないように高さを指定する
      target.find('.card').css('height', height)
      // アニメーション終了後、ボタン「次の5件」を非活性にした後に次のFAQを5件表示する
      const wait = function (seconds) {
        return new Promise(function (resolve) {
          setTimeout(resolve, seconds)
        })
      }
      wait(LOADING_TIME)
      .then(() => {
        this.messages[index].content.faqIsLoading = false
        target.find('.nextFaq').prop("disabled", true)
        target.find('.nextFaq').css({'cssText': 'color: rgba(0,0,0,.26); background-color: rgba(0,0,0,.12) !important; box-shadow: none !important;'})
        return wait(NEXT_FAQ_TIME)
      })
      .then(() => {
        target.find('.nextFaq').prop("disabled", false)
        target.find('.nextFaq').css({'cssText': defaultStyle})
        faqAnswers.each(function(index) {
          if (faqAnswers.length == (index += 1)) {
            target.hide()
          }
          if ($(this).css('display') == 'none') {
            $(this).show()
            return false
          }
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./app-common-vue/src/components/ChatMessages/ChatMessages.js